export default __webpack_public_path__ + "static/media/video.aa15be3a.mp4";